// 彈窗蓋住整頁時底層不該還能捲。
//
// 用計數而不是布林：投票確認彈窗關掉的同一輪就會開投票成功彈窗，兩邊各自「上鎖／解鎖」
// 的話會在交接的那一瞬間把整頁放開（子元件的 watcher 排在父層之後），畫面會抖一下。
// 計數歸零才真的解開，交接期間整頁都是鎖著的。
let locked = 0

function apply() {
  document.documentElement.style.overflow = locked > 0 ? 'hidden' : ''
}

export function useScrollLock() {
  // 每個呼叫端只算自己那一份，重複呼叫同一個狀態不會把計數灌爆
  let mine = false

  /**
   * 上鎖或解鎖
   * @param {boolean} on
   */
  function lockScroll(on) {
    if (!import.meta.client || on === mine) return
    mine = on
    locked = Math.max(0, locked + (on ? 1 : -1))
    apply()
  }

  // 彈窗開著時被路由帶走（頁面卸載）也要還回去，否則整站就再也捲不動了
  onScopeDispose(() => lockScroll(false))

  return { lockScroll }
}
